import { Button, useTheme } from "@mui/material";
import { IButtons } from "./Types/Buttons.types";
import { handleHeight, handleFontSize } from "./utils";

export const ButtonSecondary = ({
  onClick,
  disabled,
  startIcon,
  endIcon,
  children,
  sxButton,
  id,
  size = "sm",
}: IButtons) => {
  const theme = useTheme();
  return (
    <Button
      id={id}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: !disabled
          ? theme.palette.backgroundPrimary
          : theme.palette.backgroundDisabledAlternative,
        color: theme.palette.exploreCardText,
        padding: "0.78rem 1rem",
        opacity: disabled ? 0.3 : 1,
        height: handleHeight(size),
        lineHeight: "1.5rem",
        borderRadius: "8px",
        fontWeight: 600,
        fontSize: handleFontSize(size),
        fontStyle: "normal",
        border: `2px solid ${theme.palette.exploreCardText}`,
        "&:hover": {
          backgroundColor: theme.palette.backgroundSecondaryCTAHover,
        },
        ...sxButton,
        //TODO da finire i vari stati (active, focus)
      }}
      endIcon={endIcon}
      startIcon={startIcon}
    >
      {children}
    </Button>
  );
};
